import { MaterialTopTabBarProps } from "expo-router/js-top-tabs";
import { Key } from 'react';
import { StyleProp, StyleSheet, TouchableOpacity, View, ViewStyle } from 'react-native';

import { i18n } from '@/utils/i18n';

import Text from '../Text';

const TabBarItemDetailsMaterial = (props: MaterialTopTabBarProps) => {
  const { state, navigation } = props;

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}>
      {state.routes.map((route: { key: Key | null | undefined; name: any; params: any }, index: number) => {
        const isFirstItem = index === 0;
        const isLastItem = index === props.state.routes.length - 1;
        const styled: StyleProp<ViewStyle> = isFirstItem
          ? { borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }
          : isLastItem
            ? { borderTopRightRadius: 20, borderBottomRightRadius: 20 }
            : { borderLeftWidth: 0, borderRightWidth: 0 };
        const isFocused = state.index === index;
        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
            canPreventDefault: true
          });

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name, route.params);
          }
        };

        return (
          <TouchableOpacity onPress={onPress} key={route.key}>
            <View
              style={{
                ...styles.container,
                backgroundColor: isFocused ? 'black' : 'transparent',
                ...styled
              }}>
              <Text
                fontWeight={isFocused ? '900' : '450'}
                style={[styles.label, { color: isFocused ? 'white' : 'black' }]}>
                {i18n.t(`npo_tab.${route.name}`)}
              </Text>
            </View>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default TabBarItemDetailsMaterial;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    alignSelf: 'flex-end',
    width: 117,
    height: 34,
    marginVertical: 20,
    justifyContent: 'center',
    borderColor: '#D5D5D5',
    borderWidth: 1
  },

  content: {
    top: 0,
    zIndex: 1,
    position: 'absolute',
    width: '100%'
  },

  label: {
    fontSize: 14
  }
});
